<template>
  <section id="event-menu" v-if="eventItem">
    <div class="row py-0 justify-content-center">
    
      <h1>
        <router-link :to="'/events/'+ eventItem.id">
          <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
        </router-link>
      </h1>

      <div v-if="menuItem" class="col-12 col-lg-auto text-center">
        <h2>{{menuItem.title}}</h2>
        <div v-for="subItem in menuItem.items"
          :key="subItem.id">
          <MenuItem  
            :key="subItem.id"
            :menuItem="subItem" 
            :eventItem="eventItem" 
            :pathTo = "pathTo +'/day-'+ subItem.id"
            :menuClass="'btn-list text-uppercase'" />
        </div>
      </div>
    
    </div>
  </section>
</template>

<script>
import MenuItem from '../menu/MenuItem';

export default {
  name: 'EventsListByDay',
  props: ['id'],
  computed: {
    pathTo () {
      let path = '/events/'+ this.id +'/events/daybyday';
      return path;
    },
    eventItem () {
      return this.$store.getters.fairItemFromId(Number(this.id));
    },
    menuItem () {
      if (!this.eventItem) return false;
      let eventsItem = this.eventItem.items.find(eventsItem => eventsItem.id === "events");
      let menuItem = eventsItem.items.find(menuItem => menuItem.id === "daybyday");
      //console.log(menuItem.items);
      return menuItem;
    },
  },
  components: {
    MenuItem
  }
}
</script>

<style>
</style>

<style scoped>
</style>
